import type { Theme } from "@mui/material";

const MuiPaper = (theme: Theme) => ({
  styleOverrides: {
    elevation1: {
      boxShadow: "0px 2px 1.5px 0px rgba(0,0,0,0.08)",
      border: "solid 1px " + theme.palette.border,
    },
  },
});

export default MuiPaper;
